var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticStyle:{"height":"100vh"}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{staticClass:"full-height",staticStyle:{"overflow-y":"auto"}})],1)],1),_c('AppSnackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }